export default {
  extension: {
    widgetLabel: {
      statistic: 'Statistic',
      barChart: 'barChart',
      pieChart: 'pieChart',
      barXChart: 'barXChart',
      lineChart: "lineChart",
      funnelChart: "funnelChart",
      progressbar: "progressbar",
      radarChart: "radarChart",
      pivotTable: "pivotTable",
      listTable: "listTable"
    },
    setting: {
      //
    }
  }
};